import React from 'react';
import { IconButton } from '@mui/material';
import { InfoOutlined, ModeEditOutlineTwoTone } from '@mui/icons-material';
import { Link } from "react-router-dom";

import AppTable from "components/Shared/AppTable";
import { useVehicleDetailContext } from "contexts/VehicleDetailContext";
import { useListVehicleMaintenanceByVehicleIdQuery } from "store/services/vehicleMaintenanceApi";
import { useTablePagination } from "hooks";
import { localizeDateShort } from "utils/dateFormats";

const VehicleMaintenanceListByVehicle = () => {
    const { vehicleDetail } = useVehicleDetailContext();
    const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();

    const columns = [
        {
            name: "Maintenance",
            selector: (row) => row?.maintenanceId,
            cell: (row) =>
                row?.maintenanceId,
        },
        {
            name: "Type",
            selector: (row) => row?.maintenanceType,
            cell: (row) =>
                row?.maintenanceType,
        },
        {
            name: "Cost",
            selector: (row) => row?.cost,
            cell: (row) => `Rs. ${row?.cost}.00`,
        },
        {
            name: "Maintenance Date",
            selector: (row) => localizeDateShort(row?.maintenanceDate)
        },

        {
            name: "Condition",
            selector: (row) => row?.maintenanceCondition,
            cell: (row) => row?.maintenanceCondition || "N/A",
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <Link to={`/app/crm/vehicle-maintenance/${row?._id}/detail`}>
                        <IconButton size="small" aria-label="View Maintenance" color="primary">
                            <InfoOutlined />
                        </IconButton>
                    </Link>
                    <Link to={`/app/crm/vehicle-maintenance/${row?._id}/edit`}>
                        <IconButton size="small" aria-label="Edit Maintenance">
                            <ModeEditOutlineTwoTone />
                        </IconButton>
                    </Link>
                </>
            ),
            ignoreRowClick: true,
            right: true,
        },
    ];

    // RTK Query
    const { data: vehicleMaintenanceRs, isLoading, isFetching } =
        useListVehicleMaintenanceByVehicleIdQuery({
            vehicleId: vehicleDetail?._id,
            page: currentPage,
            limit: perPage,

        });

    return (

        <div>
            <AppTable
                columns={columns}
                data={vehicleMaintenanceRs?.data ?? []}
                progressPending={isLoading || isFetching}
                paginationServer
                paginationPerPage={perPage}
                paginationTotalRows={vehicleMaintenanceRs?.totalItems ?? 0}
                paginationDefaultPage={currentPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
            />

        </div>
    );
};

export default VehicleMaintenanceListByVehicle;

